import React, { type ReactNode, useId } from 'react';

import Alert from '@amzn/meridian/alert';
import Button from '@amzn/meridian/button';
import Column from '@amzn/meridian/column';
import Heading from '@amzn/meridian/heading';
import Row from '@amzn/meridian/row';
import LoadingSpinnerWrapper from 'src/components/shared/loadingSpinner/loadingSpinnerWrapper';

interface PlacementMetricsBandProps {
  isFetching: boolean;
  /** Shown instead of the cards, with a retry button. */
  loadError?: { message: string; onRetry: () => void };
  children?: ReactNode;
}

/** Approved Active Placements band: the heading and a row of metric cards, or an inline error. */
const PlacementMetricsBand = ({ isFetching, loadError, children }: PlacementMetricsBandProps) => {
  const headingId = useId();

  return (
    <Column tag="section" spacing="350" spacingInset="300 none none none" aria-labelledby={headingId}>
      <Heading level={2} type="h400" id={headingId}>
        Approved Active Placements
      </Heading>
      <LoadingSpinnerWrapper showSpinner={isFetching}>
        {loadError !== undefined ? (
          <Row>
            <Alert type="error">{loadError.message}</Alert>
            <Button onClick={loadError.onRetry}>Try again</Button>
          </Row>
        ) : (
          <Row widths="fill" alignmentVertical="stretch" spacing="400">
            {children}
          </Row>
        )}
      </LoadingSpinnerWrapper>
    </Column>
  );
};

export default PlacementMetricsBand;
